var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0297 4.11477L9.70969 1.09227C8.53219 0.26727 6.72469 0.31227 5.59219 1.18977L1.83469 4.12227C1.08469 4.70727 0.492188 5.90727 0.492188 6.85227V12.0273C0.492188 13.9398 2.04469 15.4998 3.95719 15.4998H12.0422C13.9547 15.4998 15.5072 13.9473 15.5072 12.0348V6.94977C15.5072 5.93727 14.8547 4.69227 14.0297 4.11477ZM11.6597 9.04977C11.6597 9.34227 11.4272 9.57477 11.1347 9.57477C10.8422 9.57477 10.6097 9.34227 10.6097 9.04977V8.91477L8.56969 10.9548C8.45719 11.0673 8.30719 11.1198 8.14969 11.1048C7.99969 11.0898 7.85719 10.9998 7.77469 10.8723L7.00969 9.73227L5.22469 11.5173C5.11969 11.6223 4.99219 11.6673 4.85719 11.6673C4.72219 11.6673 4.58719 11.6148 4.48969 11.5173C4.28719 11.3148 4.28719 10.9848 4.48969 10.7748L6.72469 8.53977C6.83719 8.42727 6.98719 8.37477 7.14469 8.38977C7.30219 8.40477 7.44469 8.48727 7.52719 8.62227L8.29219 9.76227L9.87469 8.17977H9.73969C9.44719 8.17977 9.21469 7.94727 9.21469 7.65477C9.21469 7.36227 9.44719 7.12977 9.73969 7.12977H11.1347C11.2022 7.12977 11.2697 7.14477 11.3372 7.16727C11.4647 7.21977 11.5697 7.32477 11.6222 7.45227C11.6522 7.51977 11.6597 7.58727 11.6597 7.65477V9.04977Z",
    fill: "#0044EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChart);
export default __webpack_public_path__ + "static/media/icon_chart.53c3e237f8a1db58d2b4a6be57cd264c.svg";
export { ForwardRef as ReactComponent };